module.exports = __webpack_public_path__ + "static/media/main-big.374f79c9.jpg";